import request from '@/utils/request.js'

// 学员列表
function studentsList(data) {
    return request({
        url: '/api/v1/tob/students',
        method: 'get',
        params:data
    })
}

// 学员添加
function studentsAdd(data) {
    return request({
        url: '/api/v1/tob/students',
        method: 'post',
        data
    })
}

// 学员编辑
function studentsEdit(data) {
    return request({
        url: '/api/v1/tob/students/edit',
        method: 'post',
        data
    })
}

// 重置密码
function passwordOperation(data) {
    return request({
        url: '/api/v1/tob/students/password',
        method: 'post',
        data
    })
}


// 标签列表
function tobTagsList(data) {
    return request({
        url: '/api/v1/tob/tags',
        method: 'get',
        params:data
    })
}

// 所有商品列表
function tobGoodList(data) {
    return request({
        url: '/api/v1/tob/tob-good-list',
        method: 'get',
        params:data
    })
}

// 标签添加
function tobTagsAdd(data) {
    return request({
        url: '/api/v1/tob/tags',
        method: 'post',
        data
    })
}

// 标签编辑
function tobTagsEdit(data) {
    return request({
        url: '/api/v1/tob/tags/edit',
        method: 'post',
        data
    })
}

// 标签删除
function tobTagsDelete(data) {
    return request({
        url: '/api/v1/tob/tags/del',
        method: 'post',
        data
    })
}

// 学员标签
function studentsTags(data) {
    return request({
        url: '/api/v1/tob/students/tags',
        method: 'get',
        params:data
    })
}

// 学员标签删除
function studentsTagsDel(data) {
    return request({
        url: '/api/v1/tob/students/tags/del',
        method: 'post',
        data
    })
}

// 学员标签添加
function studentsTagsAdd(data) {
    return request({
        url: '/api/v1/tob/students/tags',
        method: 'post',
        data
    })
}

// 学员批量导入
function studentsImport(data) {
    return request({
        url: '/api/v1/tob/students/import',
        method: 'post',
        data
    })
}

// 禁用学员
function studentsDisable(data) {
    return request({
        url: '/api/v1/tob/students/disable',
        method: 'post',
        data
    })
}


// 删除学员
function studentsDelete(data) {
    return request({
        url: '/api/v1/tob/students/delete',
        method: 'post',
        data
    })
}


// 【机构端】学员导入前检测重复数据
function importCheck(data) {
    return request({
        url: '/api/v1/tob/students/import-check',
        method: 'post',
        data
    })
}


// 【机构后台】学员解绑 /api/v1/tob/students/unbind
function studentsUnbind(data) {
    return request({
        url: '/api/v1/tob/students/unbind',
        method: 'post',
        data
    })
}

// 【机构后台】搜索机构 /api/v1/tob/search-group-name
function searchGroupName(data) {
    return request({
        url: '/api/v1/tob/search-group-name',
        method: 'get',
        params:data
    })
}

// 【机构后台】学员转移 /api/v1/tob/students/move
function studentsMove(data) {
    return request({
        url: '/api/v1/tob/students/move',
        method: 'post',
        data
    })
}

// 新增获取学员所有老师接口：/api/v1/tob/students/all-teacher-list 
function getAllTeacherList(data) {
    return request({
        url: '/api/v1/tob/students/all-teacher-list',
        method: 'get',
        params:data
    })
}

// 【机构端】批量关联/取消关联老师 /api/v1/tob/students/batch-teacher
function batchTeacher(data) {
    return request({
        url: '/api/v1/tob/students/batch-teacher',
        method: 'post',
        data
    })
}

// 机构后台_考生档案列表 /api/v1/tob/senioriup-user-list
function getSenioriupUserList(data) {
    return request({
        url: '/api/v1/tob/senioriup-user-list',
        method: 'get',
        params:data
    })
}
  
// function getQuestionEdus(data) {
//     return request({
//         url: '/api/v1/question/edus',
//         method: 'get',
//         params:data
//     })
// }

 
export default{
    studentsList,
    studentsAdd,
    studentsEdit,
    passwordOperation,
    tobTagsList,
    tobTagsAdd,
    tobTagsEdit,
    tobTagsDelete,
    studentsTags,
    studentsTagsAdd,
    studentsTagsDel,
    tobGoodList,
    studentsImport,
    studentsDisable,
    studentsDelete,
    importCheck,
    studentsUnbind,
    searchGroupName,
    studentsMove,
    getAllTeacherList,
    batchTeacher,
    getSenioriupUserList,
    // getQuestionEdus
}